import {AuthenticationState, AuthFlow} from '../authentication.model';
import {createReducer, on} from '@ngrx/store';
import * as AuthenticationActions from './authentication.actions';

export const authenticationFeatureKey = 'authentication';
export const initialState: AuthenticationState = {
  flow: AuthFlow.FORCE
};
export const authenticationReducer = createReducer(
  initialState,
  on(AuthenticationActions.login, (state) => ({...state, loading: true})),
  on(AuthenticationActions.signUp, (state) => ({...state, loading: true})),
  on(AuthenticationActions.loginSuccess, (state, {response}) => ({
    ...state,
    data: response,
    error: '',
    loading: false,
    flow: AuthFlow.DONE
  })),
  on(AuthenticationActions.signUpSuccess, (state, {response}) => ({
    ...state,
    error: '',
    result: response,
    loading: false,
    flow: AuthFlow.DONE
  })),
  on(AuthenticationActions.setSignUpEmail, (state, { email }) => ({
    ...state,
    signUpEmail: email
  })),
  on(AuthenticationActions.loginError, (state, {error}) => ({...state, data: undefined, error, loading: false})),
  on(AuthenticationActions.signUpError, (state, {error}) => ({...state, data: undefined, error, loading: false})),
  on(AuthenticationActions.logoutSuccess, (state) => ({
    ...initialState
  })),
  on(AuthenticationActions.cleanError, (state) => ({
    ...state,
    error: ''
  }))
);
